import PartyTarget from "../../../../model/character/PartyTarget";
import NumberFormatter from "../../../../util/NumberFormatter";
import Page from "../../../framework/Page";
import View from "../../../framework/View";

export default class TargetDepthView extends View {
    /**
     * @param {string} parentId
     * @param {PartyTarget} partyTarget
     */
    constructor(parentId, partyTarget) {
        super(parentId, parentId + '_target');

        /**
         * @constant
         * @type {PartyTarget}
         */
        this.partyTarget = partyTarget;

        /**
         * @constant
         * @type {number}
         */
        this.displayedTargetRow = -10;

        /**
         * @type {HTMLElement}
         */
        this.baseBody = null;

        this.setInitialVisibility(true);
    }

    /**
     * @override
     */
    initializeView() {

        const parentElement = Page.getElement(this.parentId);

        ////////////////////////////////////
        // total 
        ////////////////////////////////////

        const container = Page.createElement('div', parentElement, null, 'mine-damage-panel-main-section');
        const header = Page.createElement('div', container, null, 'mine-damage-panel-section-header');
        header.innerHTML = 'Target Depth';

        this.baseBody = Page.createElement('div', container, null, 'mine-damage-panel-section-body');

        super.initializeView();        
    }

    /**
     * @override
     */
    updateViewContents() {

        const targetRow = this.partyTarget.targetRow;

        if (this.displayedTargetRow != targetRow) {
            this.displayedTargetRow = targetRow;    
            this.baseBody.innerHTML = NumberFormatter.formatNumber(targetRow);
        }
    }

}